module.exports = __webpack_public_path__ + "img/default_material_img.d73c1427.svg";